import { render, staticRenderFns } from "./DraggableResource.vue?vue&type=template&id=1c41e36e"
import script from "./DraggableResource.vue?vue&type=script&lang=js"
export * from "./DraggableResource.vue?vue&type=script&lang=js"
import style0 from "./DraggableResource.vue?vue&type=style&index=0&id=1c41e36e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports